import { DialogTitle, Typography } from '@mui/material';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import useMakeDefaultCodingProfile from 'api/codingProfile/useMakeDefaultCodingProfile/useMakeDefaultCodingProfile';

const SetDefaultCodingProfileModal = ({
  guid,
  open,
  handleClose,
  onSuccess,
  loading,
}) => {
  const { makeDefault, loading: makeDefaultLoading } =
    useMakeDefaultCodingProfile();

  const onSubmit = () => {
    makeDefault(guid, () => {
      handleClose();
      onSuccess();
    });
  };

  return (
    <Dialog open={open} onClose={handleClose} sx={{ direction: 'rtl' }}>
      <DialogTitle>تنظیم به عنوان پیش‌فرض</DialogTitle>

      <DialogContent>
        <Typography>
          آیا از تنظیم این کد به عنوان پیش‌فرض مطمئن هستید؟
        </Typography>
      </DialogContent>

      <DialogActions sx={{ gap: 1, padding: 3 }}>
        <Button onClick={handleClose} variant="contained" disabled={loading}>
          انصراف
        </Button>
        <Button
          variant="contained"
          color="warning"
          onClick={onSubmit}
          disabled={makeDefaultLoading}
        >
          {makeDefaultLoading ? 'در حال پردازش...' : 'تایید'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SetDefaultCodingProfileModal;
